import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from "@angular/material/icon";
import { SatesListService } from '../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../services/raintree/Transmission/district-list.service';
import { ToastrService } from 'ngx-toastr';
import { Dp10FetchAddressService } from '../../services/raintree/Transmission/dp1.0-fetch-address.service';

@Component({
  selector: 'app-dp1.0-filter',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './dp1.0-filter.component.html',
  styleUrl: './dp1.0-filter.component.scss'
})
export class Dp10FilterComponent implements OnInit {
  filters: string[] = ['Address', 'State', 'District'];
  stateList: string[] = [];
  filteredStateList: string[] = [];
  districtList: string[] = [];
  filteredDistrictList: string[] = [];
  selectedFilterIndex: number = 0;
  selectedStateIndex: number = -1;
  selectedDistrictIndex: number = -1;
  address: FormControl = new FormControl('');
  state!: string;
  district!: string;

  constructor(
    private dialogRef: MatDialogRef<Dp10FilterComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private _dp1OS: Dp10FetchAddressService,
    private _toastrS: ToastrService
  ) { }

  ngOnInit(): void {
    this.address.setValue(this.data.add!);
    this.state = this.data.st!;
    this.district = this.data.dt!;
    this.getStateList();
  }

  getStateList() {
    this._dp1OS.fetchStateDp10({ uiCountry: this.data.country }).subscribe({
      next: (result: any) => {
        if (!result.error && result.data.length > 0) {
          this.stateList = [];
          this.filteredStateList = [];
          result.data.forEach((st: any) => {
            this.filteredStateList.push(st?.state_name)
          });
          this.stateList = this.filteredStateList;
          if (this.data.st) {
            this.selectedStateIndex = this.stateList.indexOf(this.data.st)
            this.getDistrictList(this.data.st);
          }
        }
      },
      error: (error: any) => {
        this._toastrS.clear();
        this._toastrS.error(error);
      }
    })
  }

  onEnterState(e: any) {
    console.log(e.target.value)
    const st = e.target.value;
    this.filteredStateList = this.stateList.filter(stnm => stnm.toLocaleLowerCase().includes(st.toLowerCase()))
  }

  onSelectState(index: number) {
    this.selectedStateIndex = index;
    this.state = this.filteredStateList[index];
    this.getDistrictList(this.state);
  }

  getDistrictList(state: string) {
    this.district = state.toLowerCase() !== this.data.st?.toLowerCase() ? '' : this.data.dt;
    this._dp1OS.fetchStateDp10({ uiCountry: this.data.country, state: state }).subscribe({
      next: (result: any) => {
        if (!result.error && result.data.length > 0) {
          this.districtList = [];
          this.filteredDistrictList = [];
          result.data.forEach((dt: any) => {
            this.filteredDistrictList.push(dt.district_name)
          });
          this.districtList = this.filteredDistrictList;
          if (this.data.dt) {
            this.selectedDistrictIndex = this.districtList.indexOf(this.data.dt)
          }
        }
      },
      error: (error: any) => {
        this._toastrS.clear();
        this._toastrS.error(error);
      }
    })
  }

  onEnterDistrict(e: any) {
    const dt = e.target.value;
    this.filteredDistrictList = this.districtList.filter(stnm => stnm.toLocaleLowerCase().includes(dt.toLowerCase()))
  }

  onSelectDistrict(index: number) {
    this.selectedDistrictIndex = index;
    this.district = this.filteredDistrictList[index];
  }

  close() {
    this.dialogRef.close(null)
  }

  resetFilter() {
    this.data = {country: this.data.country};
    this.address.setValue('');
    this.state = '';
    this.district = '';
    this.selectedStateIndex = -1;
    this.selectedDistrictIndex = -1;
    this.selectedFilterIndex = 0;
    this.stateList = [];
    this.filteredStateList = [];
    this.districtList = [];
    this.filteredDistrictList = [];
    this.getStateList();
  }

  onApplyFilter() {
    const filterPayload = {
      add: this.address.value ? this.address.value : null,
      st: this.state ? this.state : null,
      dt: this.district ? this.district : null
    }
    this.dialogRef.close(filterPayload);
  }
}
